import { useMapEvents } from 'react-leaflet';

export default function ZoomOnFocusMapEvent({ setInteracted }) {
  useMapEvents({
    focus: () => {
      setInteracted(true); // Set interacted state to true
    },
    drag: () => {
      setInteracted(true); // Set interacted state to true
    },
  });

  return null;
}
